
export class NotificationLog {
  constructor(
    public readonly id: string,
    public readonly type: string,
    public readonly status: 'pending' | 'sent' | 'success' | 'failed',
    public readonly receiverName: string,
    public readonly title: string,
    public readonly preview: string,
    public readonly created_at: Date,
    public readonly updated_at: Date
  ) {
  }

  static fromJson(json: any): NotificationLog {
    return new NotificationLog(
      json['id'],
      json['type'],
      json['status'],
      json['receiver_name'],
      json['title'],
      json['preview'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }
}